<template>
  <div>
    <div><span @click="gotoChangePassword('personalInfo')">个人信息</span><span>></span><span>更改手机号</span></div>
    <div class="login">
      <div class="center_box t-10">
        <div class="login_min mt0">
          <vue-form :state="formstate" id="loginForm">
            <validate tag="div" class="p_rel">
              <p>当前账户密码</p>
              <input class="pass_word" v-model="params.pre_password" type="text" name="newPassword" placeholder="" required pattern="^\d{6}$">
              <field-messages name="newPassword" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">密码不能为空</div>
                <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
              </field-messages>
            </validate>
            <validate tag="div" class="p_rel">
              <p>新手机号</p>
              <input id="password" class="pass_word" type="text" v-model="params.new_mobile" name="new_mobile" placeholder="" required pattern="^[1][0-9]{10}$">
              <field-messages name="new_mobile" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">手机号不能为空</div>
                <div slot="pattern" class="errorMessage">请填写正确的手机号</div>
              </field-messages>
            </validate>
            <validate tag="div" class="p_rel">
              <p>验证码</p>
              <div class="clearfix">
                <input id="" class="pass_word i_w200 fl" type="text" v-model="params.code" name="shotCode" placeholder="" required pattern="^\d{6}$">
                <input class="pass_word i_w100 fr" :class="{can_login:!smsBtnDisabled}" @click="getSmsCode" type="button" :disabled="smsBtnDisabled" :value="smsBtnTxt">
              </div>
              <field-messages name="shotCode" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">手机验证码不能为空</div>
                <div slot="pattern" class="errorMessage">请填写正确的手机验证码</div>
              </field-messages>
            </validate>
            <div>
              <button id="login" :class="{can_login:disabled==true}" @click.prevent="toChangePhone" :disabled="!disabled">完成</button>
            </div>
          </vue-form>
        </div>
      </div>
      <toastTips :content="toastContent" :is-show="toast"></toastTips>
    </div>
  </div>

</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import toastTips from '../../components/layer/toastTips'
  export default {
    name: 'changePhone',
    components:{
      toastTips
    },
    data () {
      return {
        formstate:{},
        params:{
          pre_password:'',
          new_mobile:'',
          code:''
        },
        disabled:false,
        toast:false,
        toastContent:'',
        smsBtnTxt:'点击获取',
        smsBtnDisabled:false
      }
    },
    methods:{
      getSmsCode:function(){
        this.smsBtnDisabled=true;
        axios.post('/login/sendSms',qs.stringify(
          {
            mobile:this.params.new_mobile,
            type:'reset'
          }
        )).then((response)=>{
          var that=this;
          console.log(response);
          if(response.data.code == 22000){
            let num = 60;
            let timer = setInterval(function(){
              if(num!=0){
                num--;
                that.smsBtnTxt=num+'秒后重发';
              }else{
                num=60;
                that.smsBtnTxt='点击获取';
                that.smsBtnDisabled=false;
                clearInterval(timer);
              }

            },1000);
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            this.smsBtnDisabled=false;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      toChangePhone:function(){
        var that=this;
        axios.post('/admin/updateMobile',qs.stringify(
          this.params
        )).then((response)=>{

          if(response.data.code == 22000){
            window.location.href='/#/list/5'
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      gotoChangePassword:function(changItem){
        this.$emit('changePassWord',changItem);
      }
    },
    watch:{
      'formstate.$invalid':function(){
        if(!this.formstate.$invalid){
          this.disabled=true;
        }else{
          this.disabled=false;
        }

      }
    }
  }
</script>
<style lang="less" scoped>
  .l-h70{
    line-height: 70px;
  }
  .login_min{
  div{
    margin-top: 10px;
  p{
    line-height: 40px;
    font-size: 16px;
  }
  }
  }
  .t80{
    top:80px!important;
  }
  .t-10{
    top: 10%!important;
    margin-top: 0!important;
  }
  .p_rel{
    position: relative !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal_center/changePhone.vue